<template>
  <Transition name="fade">
    <aside
      v-if="$store.state.modal_video"
      class="video__background"
      @click="$store.dispatch('closeModalVideo')"
    >
      <div class="video__modale">
        <div class="video__content">
          <div class="video">
            <iframe
              src="https://player.vimeo.com/video/804374024?h=49e5e3896b&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
              frameborder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowfullscreen
              style="width: 100%; height: 100%"
              title="DVSF - Promo 2022 Vfinale.mp4"
            ></iframe>
          </div>
          <button class="button__circle video__button" @click="$store.dispatch('closeModalVideo')">
            <Icon id="close" />
          </button>
        </div>
      </div>
    </aside>
  </Transition>
</template>

<script>
import Icon from '@/components/global/Icon.vue'

export default {
  name: 'VideoModal',
  components: { Icon },
  watch: {
    '$store.state.modal_video': {
      handler: function (value) {
        if (value && !document.body.classList.contains('--lock')) {
          document.body.classList.add('--lock')
        } else if (!value && document.body.classList.contains('--lock')) {
          document.body.classList.remove('--lock')
        }
      },
      immediate: true,
    },
  },
}
</script>
